import { Spinfinity } from 'components';
import useFeature from 'services/features/useFeature';
import { ConditionMetricsDetailView } from './ConditionMetricsDetailView';
import { LegacyConditionMetricsDetailView } from './ConditionMetricsDetailView.legacy';

/**
 * Routes the condition detail page by the gut_x_axis flag: on → the redesigned
 * detail (all kit types, gut and vaginal), off → the previous experience.
 */
export const ConditionsDetailFlagGate = () => {
  const { isFeatureEnabled, isLoading } = useFeature('gut_x_axis');

  if (isLoading) return <Spinfinity />;

  return isFeatureEnabled ? (
    <ConditionMetricsDetailView />
  ) : (
    <LegacyConditionMetricsDetailView />
  );
};
